import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { DATE } from "helpers/shapes"
import CompareChart from "components/charts/compare"
import NotEnoughData from "components/not-enough-data"
import CompareTable from "components/compare-table"
import CompareSelect from "components/material/compare-select"
import { smallPercentageFormatter, oneDecimalPercentageFormatter } from "helpers/formatters/numbers"
import { FACTOR_CATEGORIES_SHAPE } from "components/factor-categories/shapes"
import { DATA, DOWNLOAD_FILENAME, METRICS, SELECTED_METRIC, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import "./styles.scss"

export default function ComparePerformance({
  data,
  isOpPro,
  metrics,
  fixedItemNumber,
  status,
  startDate,
  endDate,
  selectedDate,
  setDate,
  selectedMetric,
  items,
  detailsItems,
  detailsData,
  trackPanelTrigger,
  portfolioId,
  account,
  factorCategories,
  setMetric,
  saveMetricToStore,
  fileName,
  tableDownloadData,
}) {
  const selectedView = "performance"
  return <Paper className="modules_compare-performance" square elevation={1}>
    <div className="wrapper">
      {data && data.length > 0
        ? <>
          <CompareChart
            tooltipFormatter={smallPercentageFormatter}
            metricSelector={<CompareSelect
              options={metrics}
              selectedOption={selectedMetric}
              setSelected={setMetric}
              saveToStore={saveMetricToStore}
              storeName={selectedView}
            />}
            {...{
                status,
                tickFormat: oneDecimalPercentageFormatter,
                startDate,
                date: selectedDate,
                setDate,
                endDate,
                data,
                items,
                fixedItemNumber,
                fileName,
                tableDownloadData,
                selectedView,
                percents: true,
              }}
          />
          <CompareTable {...{
              items: detailsItems,
              data: detailsData,
              columns: items,
              trackPanelTrigger,
              fixedItemNumber,
              factorCategories,
            }}
          />
        </>
        : <NotEnoughData portfolio={portfolioId} account={account} isOpPro={isOpPro} />}
    </div>
  </Paper>
}

ComparePerformance.propTypes = {
  status: PropTypes.string.isRequired,
  portfolioId: PropTypes.string,
  account: PropTypes.string.isRequired,
  data: DATA.isRequired,
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  selectedDate: DATE,
  setDate: PropTypes.func.isRequired,
  metrics: METRICS.isRequired,
  selectedMetric: SELECTED_METRIC.isRequired,
  setMetric: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  })).isRequired,
  detailsItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    defaultOpen: PropTypes.bool,
    fn: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
    })),
  })).isRequired,
  detailsData: PropTypes.array.isRequired,
  saveMetricToStore: PropTypes.func.isRequired,
  trackPanelTrigger: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  isOpPro: PropTypes.bool.isRequired,
  factorCategories: FACTOR_CATEGORIES_SHAPE,
  fileName: DOWNLOAD_FILENAME,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
}
